export default function PHP_strstr() {
  return (
    <div>
      <h1>PHP_strstr</h1>
    </div>
  );
}
